export class LookupModel {
    constructor(public Text?: string, public Value?: number) {
    }
}